
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { StrictMode } from 'react'
import { Capacitor } from '@capacitor/core';
import {
  FpjsProvider
} from '@fingerprintjs/fingerprintjs-pro-react';
import {Analytics} from '@vercel/analytics/react';
import {SpeedInsights} from '@vercel/speed-insights/react';
import { AuthProvider } from './contexts/AuthContext';

// Initialize the root element
const root = createRoot(document.getElementById("root")!);

// Check for mobile platform
const isMobile = Capacitor.isNativePlatform();

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
}

// Remove the BrowserRouter here since it already exists in App.tsx
root.render(
  <StrictMode>
    <FpjsProvider
      loadOptions={{
        apiKey: "IB2VvlDTZ4YWaA26hZqc",
        region: "eu"
      }}
    >
    <AuthProvider>
      <App />
    </AuthProvider>
    </FpjsProvider>
    <Analytics mode='production' />
    <SpeedInsights />
  </StrictMode>
);
